/**
 * Boton base (patron shadcn/ui) adaptado al perfil KIOSCO.
 *
 * Diferencias respecto al shadcn estandar:
 *  - No existe tamano pequeno: el minimo es 88px de alto (objetivo tactil).
 *  - Bordes de 2px y texto en negrita para contraste con luz ambiente.
 */
import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const variantesBoton = cva(
  'inline-flex items-center justify-center gap-3 whitespace-nowrap rounded-lg font-semibold ' +
    'transition-colors disabled:pointer-events-none disabled:opacity-50 select-none',
  {
    variants: {
      variante: {
        principal: 'bg-primary text-primary-foreground hover:bg-primary/90',
        secundario: 'bg-secondary text-secondary-foreground hover:bg-secondary/80',
        contorno: 'border-2 border-border bg-transparent hover:bg-secondary',
        destructivo: 'bg-destructive text-destructive-foreground hover:bg-destructive/90',
        afirmativo: 'bg-[hsl(var(--cobro))] text-background hover:opacity-90',
        fantasma: 'bg-transparent hover:bg-secondary',
      },
      tamano: {
        // Todos cumplen el minimo tactil; solo cambia el ancho y la tipografia.
        normal: 'min-h-tactil px-8 text-lg',
        ancho: 'min-h-tactil w-full px-8 text-lg',
        grande: 'min-h-[7rem] px-12 text-2xl',
        icono: 'min-h-tactil min-w-tactil p-0',
      },
    },
    defaultVariants: { variante: 'principal', tamano: 'normal' },
  },
);

export interface PropsBoton
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof variantesBoton> {}

export const Boton = React.forwardRef<HTMLButtonElement, PropsBoton>(
  ({ className, variante, tamano, type = 'button', ...props }, ref) => (
    <button
      ref={ref}
      type={type}
      className={cn(variantesBoton({ variante, tamano }), className)}
      {...props}
    />
  ),
);
Boton.displayName = 'Boton';

export { variantesBoton };
